import React from "react";
import { RangeDateType } from "../calendar/DateProps";

export const RangePickerContext = React.createContext<{
  range?: RangeDateType;
}>({});
